export default __webpack_public_path__ + "static/media/suspended.cf584013.svg";